<template>
  <v-card class="pa-5">
    <v-btn class="btn-close" icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
    <h2 class="primary--text mb-4">Review Template</h2>
    <v-form ref="reviewTemplateForm">
      <div>
        <label class="form-label">Customer</label>
        <v-text-field v-model="form.customerName" :rules="rules.customerName" outlined dense></v-text-field>
      </div>
      <div>
        <label class="form-label">Email</label>
        <v-text-field v-model="form.customerEmail" :rules="rules.customerName" outlined dense></v-text-field>
      </div>
      <div class="mb-4">
        <label class="form-label">Stars</label>
        <v-rating color="warning" length="5" v-model="form.rating"></v-rating>
      </div>
      <div>
        <label class="form-label">Review</label>
        <v-textarea v-model="form.review" outlined dense></v-textarea>
      </div>
      <div>
        <label class="form-label">Tags</label>
        <v-combobox
          v-model.trim="form.tags"
          hide-selected
          multiple
          persistent-hint
          small-chips
          append-icon=""
          :delimiters="[',']"
          outlined
          dense
        >
          <template v-slot:selection="data">
            <v-chip
              close
              small
              label
              :key="data.item"
              :disabled="data.disabled"
              @click:close="data.parent.selectItem(data.item)"
            >
              {{ data.item }}
            </v-chip>
          </template>
        </v-combobox>
      </div>
      <div>
        <label class="form-label">Images ({{ form.images.length }}/255)</label>
        <Images :images="form.images" @updateImages="onChangeImages" />
      </div>
    </v-form>
    <div class="d-flex justify-end mt-4">
      <v-btn color="primary" :disabled="loading" text dark @click="$emit('close')">Cancel</v-btn>
      <v-btn color="primary" :loading="loading" text dark @click="onSave">Save changes</v-btn>
    </div>
  </v-card>
</template>
<script>
import Images from './images'
import ApiService from '@/common/api.service'
export default {
  components: { Images },
  props: ['reviewTemplate'],
  data() {
    return {
      loading: false,
      form: {
        customerName: null,
        review: null,
        rating: 5,
        images: [],
        tags: [],
      },
      rules: {
        customerName: [(v) => !!v || 'This field is required!'],
      },
    }
  },
  methods: {
    async onSave() {
      if (this.$refs.reviewTemplateForm.validate()) {
        try {
          this.loading = true
          await ApiService.put('/reviews/review-template/' + this.form._id, this.form)
          this.$emit('close')
        } catch (error) {
          console.log('🚀 ~ file: request-modal.vue:46 ~ onSave ~ error:', error)
        } finally {
          this.loading = false
        }
      }
    },
    onChangeImages(images) {
      this.form.images = images
    },
  },
  created() {
    this.form = { ...this.reviewTemplate }
  },
}
</script>

<style lang="scss" scoped>
.v-card {
  position: relative;
  button.btn-close {
    position: absolute;
    right: 12px;
    top: 12px;
  }
}
</style>
